import ApolloClient from "apollo-boost";
import fetch from "isomorphic-fetch";
import Cookies from "js-cookie";

const client = new ApolloClient({
  uri: process.env.GATSBY_GRAPHQL_ENDPOINT,
  fetch,
  request: operation => {
    const userCookie = Cookies.get("user");
    operation.setContext({
      headers: {
        authorization: userCookie
          ? `Bearer ${JSON.parse(userCookie).token}`
          : "",
      },
    });
  },
});

export default client;
